module.exports = __webpack_public_path__ + "static/pochette-cc04591c16686cc2c13a1314f56a51e1.jpg";